export const BlogGridBodyData = [
  {
    avatar: "blog/about/1.png",
    image: "blog/grid-1.jpg",
    name: "Erin M. Baker",
    date: "Feb 6,2024",
    title: "Mobile App Development",
    content: "Mobile Simple log in – logging in to your website is easy. They have added a dedicated login page inside the app.",
    views: "8k views",
  },
  {
    avatar: "blog/about/2.png",
    image: "blog/grid-2.jpg",
    name: "Amy A. Servants",
    date: "Feb 2,2024",
    title: "Publish Policy",
    content: "The new rules classify companies with more than 45 million users as very. The laptop visible with some text and icons on it.",
    views: "2k views",
  },
  {
    avatar: "blog/about/3.png",
    image: "blog/grid-3.jpg",
    name: "Jackie M. Martin",
    date: "Feb 9,2024",
    title: "Cozy Workspace",
    content: "The image is designed to convey a sense of comfort and warmth, as seen from the soft lighting and the cozy wooden.",
    views: "12k views",
  },
  {
    avatar: "blog/about/4.png",
    image: "blog/grid-4.jpg",
    name: "Mary S. Jelks",
    date: "Jan 25,2024",
    title: "Take the stress out of code",
    content: "Are you wondering how to get a text short code and get start with reaching your customers in new SMS into steps.",
    views: "5k views",
  },
  {
    avatar: "blog/about/5.png",
    image: "blog/grid-5.jpg",
    name: "Kathe W. Williams",
    date: "Jan 5,2024",
    title: "Myths about code",
    content: "All of the paragraphs in the are written by humans. thought about to generate the paragraph, but they weren't very.",
    views: "4k views",
  },
  {
    avatar: "blog/about/6.png",
    image: "blog/grid-6.jpg",
    name: "Anna G. Proas",
    date: "Dec 31, 2024",
    title: "Old School Coded",
    content: "Particular I learned about our mental and physical limits, the nature of stress and anxiety, and most importantly.",
    views: "11k views",
  },
];

export const BlogGridListData = [
  {
    title: "Top Men’s Fashion Trends From Spring",
    content: "Offer budget-friendly alternatives and shopping tips for men who want to stay on-trend without breaking the bank, such as shopping at thrift stores or opting for affordable brands.",
    date: "25 May 2024",
    author: "Admin",
    comments: "10 Comments",
    link: "blog-details.html",
  },
  {
    title: "Spicy Crispy Chicken Burger Recipe",
    content: "Share tips for meal prepping burger components ahead of time, such as preparing the chicken patties in advance or making extra sauce for later use, provide tips for the perfect crispy chicken.",
    date: "15 July 2024",
    author: "Admin",
    comments: "11 Comments",
  },
  {
    title: "Headsets Are Better if You’re Playing Game",
    content: "Explain how headsets with surround sound capabilities improve spatial awareness in games, allowing players to pinpoint the direction of in-game sounds such as footsteps or gunfire.",
    date: "14 June 2024",
    author: "Admin",
    comments: "18",
  },
  {
    title: "Mistakes You Might Be Making With Watch",
    content: "Overwinding mechanical watches can cause serious damage to the movement. Content could explain how to properly wind mechanical watches and recognize when they are fully wound.",
    date: "10 April 2024",
    author: "Admin",
    comments: "15 Comments",
  },
];

export const TrendingPostsData = [
  {
    id: "01",
    title: "Mistakes You Might Be Making With Watch",
    date: "June 29, 2024",
  },
  {
    id: "02",
    title: "Top Men’s Fashion Trends From Spring",
    date: "May 11, 2024",
  },
  {
    id: "03",
    title: "Surprising Benefits of Honeydew Melon",
    date: "March 25, 2024",
  },
  {
    id: "04",
    title: "Spicy Crispy Chicken Burger Recipe",
    date: "July 17, 2024",
  },
  {
    id: "05",
    title: "Headsets Are Better if You’re Playing Games",
    date: "April 22, 2024",
  },
];

export const FollowUsData = [
  {
    href: "https://en-gb.facebook.com/login/",
    icon: "fa-facebook-square",
  },
  {
    href: "https://twitter.com/LOGIN",
    icon: "fa-twitter",
  },
  {
    href: "https://www.instagram.com/accounts/login/",
    icon: "fa-instagram",
  },
  {
    href: "https://www.skype.com/en/",
    icon: "fa-skype",
  },
  {
    href: "https://www.linkedin.com/login",
    icon: "fa-linkedin",
  },
];

export const RecentPostsData = [
  {
    image: "blog/small/1.jpg",
    title: "Gadgets That Will Upgrade Your Home",
    timeAgo: "4 months ago",
  },
  {
    image: "blog/small/2.jpg",
    title: "Headsets Are Better if You’re Playing Games",
    timeAgo: "5 months ago",
  },
  {
    image: "blog/small/3.jpg",
    title: "Laugh, Cry and Learn Within Virtual Reality",
    timeAgo: "7 months ago",
  },
  {
    image: "blog/small/4.jpg",
    title: "Mistakes You Might Be Making With Your Watch",
    timeAgo: "8 months ago",
  },
];

export const PopularTagsData = ["Design", "Clean", "CSS3", "Portfolio", "Pixelstrap", "Perfect", "No Jquery"];

export const BlogCommentsData = [
  {
    avatar: "avtar/4.jpg",
    name: "Sophia Johnson",
    date: "12 May 2024 at 1:30AM",
    content: "The gig economy is changing the way we work and the nature of employment. It offers flexibility and opportunities for freelancers, but it also raises questions about job security and benefits. Ethical considerations are paramount when it comes to technology and business. Companies need to prioritize transparency, accountability, and responsible use of data to build trust with customers and stakeholders.",
  },
  {
    avatar: "avtar/7.jpg",
    name: "Noah Johnson",
    date: "18 April 2024 at 5:25AM",
    replyClass: "replay",
    content: "Cybersecurity is a major concern for businesses of all sizes. With the rise of cyber threats, investing in robust security measures is non-negotiable for protecting sensitive data and maintaining customer trust.",
  },
  {
    avatar: "avtar/16.jpg",
    name: "James Martinez",
    date: "15 August 2024 at 4:15AM",
    content: "It's fascinating to see how businesses are leveraging technology to stay competitive in today's market. The innovations in AI and data analytics are truly game-changers, digital transformation is essential for businesses to thrive in the digital age. It's not just about adopting new technologies but also about reshaping organizational culture and processes.",
  },
];

//Add Post
export const DataTypeAhead = [{ name: "Lifestyle" }, { name: "Travel" }, { name: "Food" }, { name: "Beauty" }];

export const PostEditRadios = [
  { id: 1, text: "Text" },
  { id: 2, text: "Image" },
  { id: 3, text: "Audio", check: "checked" },
  { id: 4, text: "Video" },
];
